var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bannerList"},[_c('el-carousel',{attrs:{"height":"125px","arrow":"never","indicator-position":"none"}},[_c('el-carousel-item',[_c('img',{attrs:{"src":_vm.banner.url,"alt":""}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }